import { render } from "./NewBlockCard.vue?vue&type=template&id=7c76b241&ts=true"
import script from "./NewBlockCard.vue?vue&type=script&lang=ts"
export * from "./NewBlockCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__